export const CARBON_RATIO_STATUS = {
  BAD: 1,
  NORMAL: 2,
  GOOD: 3,
};
